import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import SuccessOverlay from "../../UserComponents/overlays/SuccessOverlay.js";
import AllRulesModal from "../../UserComponents/modals/AllRulesModal.js";
import ErrorOverlay from "../../UserComponents/overlays/ErrorOverlay.js";
import UserSubscriptionsList from "../../UserComponents/modals/UserSubscriptions.js";
import { useSelector, useDispatch } from "react-redux";
import { GetAllRulesAction } from "../../redux/actions/game.actions.js";
import { createTeam } from "../../services/team.services.js";
import { isValidEmail } from "../../utils/helper.js";
import { useHistory } from "react-router-dom";
import {
  getUserSubscriptions,
  assignSubscription,
} from "../../services/user.services.js";
import "./createteam.css";

const initialState = {
  teamName: "",
  teamNickName: "",
  gameRules: "",
  teamOwner: "",
  coachName: "",
  coachCell: "",
  coachEmail: "",
};

const CreateTeam = (props) => {
  const teamData = props.handleGetAllTeams;
  const history = useHistory();

  const [visible2, setVisible2] = useState(false);
  const [subsLoading, setSubsLoading] = useState(true);
  const dispatch = useDispatch();
  const allRules = useSelector((state) => state.gameRules.allRules);
  const user = useSelector((state) => state.auth.user);
  const userId = props.userId;

  const [userSubsData, setUserSubsData] = useState(null);
  const [selectedSubscription, setSelectedSubscription] = useState(null);
  const [subscriptionVisible, setSubscriptionVisible] = useState(false);
  const toggleSubscriptions = () => setSubscriptionVisible(!subscriptionVisible);

  const [groupModal, setGroupModal] = useState(false);
  const [selectedRule, setSelectedRule] = useState(null);
  const [initialStateForm, setInitialStateForm] = useState(initialState);
  const [displayPhone, setDisplayPhone] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleFormChange = (name, value) => {
    setInitialStateForm((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const toggleSuccessModal = () => {
    setVisible2(true);
    setTimeout(() => {
      props.goBack();
      setVisible2(false);
    }, 2500);
  };

  const handleSelectGroup = (val) => {
    setSelectedRule(val);
    handleFormChange("gameRules", val._id);
    setGroupModal(false);
  };

  useEffect(() => {
    const fetchSubscriptions = async () => {
      try {
        setSubsLoading(true); // start loading
        const response = await getUserSubscriptions(
          {
            userId: userId || user._id,
          },
          user?.token
        );
        setUserSubsData(response.data);
      } catch (error) {
        console.error("Error fetching user subscriptions:", error);
        setUserSubsData([]); // fallback to empty array
      } finally {
        setSubsLoading(false); // end loading
      }
    };
    fetchSubscriptions();
  }, [userId, user]);


  useEffect(() => {
    dispatch(GetAllRulesAction(user?.token));
    handleFormChange("teamOwner", user._id);
  }, [dispatch, user]);

  useEffect(() => {
    const phoneLength = initialStateForm.coachCell.length;
    let formattedNumber = "";

    if (phoneLength < 4) {
      formattedNumber = initialStateForm.coachCell;
    } else if (phoneLength > 3 && phoneLength < 7) {
      formattedNumber = `(${initialStateForm.coachCell.slice(
        0,
        3
      )}) ${initialStateForm.coachCell.slice(3)}`;
    } else {
      formattedNumber = `(${initialStateForm.coachCell.slice(
        0,
        3
      )}) ${initialStateForm.coachCell.slice(3, 6)}-${initialStateForm.coachCell.slice(6)}`;
    }

    setDisplayPhone(formattedNumber);
  }, [initialStateForm.coachCell]);

  const handleCreate = async () => {
    const emailLength = initialStateForm.coachEmail.length;
    try {
      if (emailLength > 0 && !isValidEmail(initialStateForm.coachEmail)) {
        throw new Error("Invalid email format!");
      }
      setLoading(true);
      const response = await createTeam(initialStateForm, user?.token);
      await handleAssignSubscription(response.data._id);
      toggleSuccessModal();
      history.push('/selectteam')
    } catch (e) {
      setError(e);
      console.error("Error creating team:", e?.response?.data);
    } finally {
      setLoading(false);
    }
  };

  const handleAssignSubscription = async (createdTeamId) => {
    try {
      await assignSubscription(
        {
          teamId: createdTeamId,
          subscriptionId: selectedSubscription?._id,
        },
        user?.token
      );
    } catch (e) {
      throw e;
    }
  };

  const toggleGroupModal = () => {
    setGroupModal(!groupModal);
  };

  return (
    <div className="containerCreateTeam">
      <ErrorOverlay
        visible={!!error}
        error={error}
        onBackdropPress={() => setError(null)}
      />

      <div className="headerCreateTeam">
        {/* <button className="back-btn" onClick={props.goBack}>
          &#8592; Back
        </button> */}
        <h2 className="headerTxt">ADD LICENSE TEAM</h2>
      </div>

      <form className="createTeamForm" onSubmit={(e) => e.preventDefault()}>
        <div className="nameInputRowCreateTeam">
          <label className="nameTxtCreateTeam">Team Name:</label>
          <input
            className="inputCreateTeam"
            type="text"
            placeholder="Enter team name"
            value={initialStateForm.teamName}
            onChange={(e) => handleFormChange("teamName", e.target.value)}
          />
        </div>

        <div className="nameInputRowCreateTeam">
          <label className="nameTxtCreateTeam">Nickname:</label>
          <input
            className="inputCreateTeam"
            type="text"
            placeholder="Enter team nickname"
            value={initialStateForm.teamNickName}
            onChange={(e) => handleFormChange("teamNickName", e.target.value)}
          />
        </div>

        <div className="nameInputRowCreateTeam">
          <label className="nameTxtCreateTeam">Coach Name:</label>
          <input
            className="inputCreateTeam"
            type="text"
            placeholder="Enter coach name"
            value={initialStateForm.coachName}
            onChange={(e) => handleFormChange("coachName", e.target.value)}
          />
        </div>

        <div className="nameInputRowCreateTeam">
          <label className="nameTxtCreateTeam">Coach Cell #:</label>
          <input
            className="inputCreateTeam"
            type="text"
            placeholder="Enter coach number"
            value={isFocused ? initialStateForm.coachCell : displayPhone}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            onChange={(e) => handleFormChange("coachCell", e.target.value)}
          />
        </div>

        <div className="nameInputRowCreateTeam">
          <label className="nameTxtCreateTeam">Coach Email:</label>
          <input
            className="inputCreateTeam"
            type="email"
            placeholder="Enter coach email"
            value={initialStateForm.coachEmail}
            onChange={(e) => handleFormChange("coachEmail", e.target.value)}
          />
        </div>

        <div className="nameInputRowCreateTeam">
          <label className="nameTxtCreateTeam">Game Rules:</label>
          <button onClick={toggleGroupModal} className="inputCreateTeam">
            {selectedRule?.ruleName || "Select game rules"}
          </button>
        </div>

        <div className="nameInputRowCreateTeam">
          <label className="nameTxtCreateTeam">Subscription:</label>
          <input
            className="inputCreateTeam"
            type="text"
            placeholder="Select subscription"
            value={selectedSubscription?.subscriptionType.subscriptionName || ""}
            readOnly
            onClick={toggleSubscriptions}
          />
        </div>

        <button
          className="saveBtnCreateTeam"
          onClick={handleCreate}
          disabled={loading}
        >
          {loading ? "Creating..." : "Create"}
        </button>
      </form>

      <UserSubscriptionsList
        data={userSubsData || []}
        loading={subsLoading}   // <-- add this
        setSelectedSubscription={setSelectedSubscription}
        visible={subscriptionVisible}
        onClose={toggleSubscriptions}
      />

      <AllRulesModal
        data={allRules || []}
        setSelectedRule={handleSelectGroup}
        groupModal={groupModal}
        closeModal={() => setGroupModal(false)}
      />

      {visible2 && (
        <SuccessOverlay
          isVisible={visible2}
          message="Team has been added successfully!"
          onClose={() => toggleSuccessModal(false)}
        />
      )}
    </div>
  );
};

export default CreateTeam;
